import { SxProps } from "@mui/material";

export const sxButtonExcluirConta: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  maxWidth: '200px',
  '@media (max-width: 768px)': {
    maxWidth: '340px',
    width: 'stretch'
  }
}

export const sxInputCpf: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  width: '300px',
  '@media (max-width: 768px)': {
    maxWidth: '340px',
    width: 'stretch'
  }
}